import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {NzMessageService, NzModalService, isTemplateRef} from 'ng-zorro-antd';
import { ModalConfig } from '../../entities/modal-config';


@Component({
  selector: 'app-s-modal',
  templateUrl: './s-modal.component.html',
  styleUrls: ['./s-modal.component.less']
})
export class SModalComponent implements OnInit {
  @Input() modalData: ModalConfig;

  constructor(
    private messageService: NzMessageService,
    private modalService: NzModalService
  ) { }

  ngOnInit(): void {

  }

}
